import { field, hidden, nullable, print } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";

@model("ProductTrackingNumber")
export class ProductTrackingNumber {
	@field("number")
	@hidden()
	ProductID:number = 0;

	@field("string")
	@hidden()
	ProductSku:string = "";

	@field("string")
	TrackingNumber:string = "";

	@field("date")
	@nullable()
	@print(printLocalDate)
	ValidUntil:Date | null = null;

	@field("number")
	@print(printHumanFloat)
	Location1Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location2Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location3Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location4Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location5Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location6Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location7Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location8Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location9Qty:number = 0.0;

	public constructor(data?:any) {
		if (!data) return;
		this.ProductID = data.ProductID;
		this.ProductSku = data.ProductSku;
		this.TrackingNumber = data.TrackingNumber;
		this.ValidUntil = data.ValidUntil ? new Date(data.ValidUntil) : null;
		this.Location1Qty = data.Location1Qty;
		this.Location2Qty = data.Location2Qty;
		this.Location3Qty = data.Location3Qty;
		this.Location4Qty = data.Location4Qty;
		this.Location5Qty = data.Location5Qty;
		this.Location6Qty = data.Location6Qty;
		this.Location7Qty = data.Location7Qty;
		this.Location8Qty = data.Location8Qty;
		this.Location9Qty = data.Location9Qty;
	}

	public getTotalInStock():number{
		return this.Location1Qty +
		this.Location2Qty +
		this.Location3Qty +
		this.Location4Qty +
		this.Location5Qty +
		this.Location6Qty +
		this.Location7Qty +
		this.Location8Qty +
		this.Location9Qty;
	}

	public getValidUntilString():string{
		if (!this.ValidUntil) return "";
		return printLocalDate(this.ValidUntil);
	}
}